module.exports = __webpack_public_path__ + "img/2f_r_kokoro.06c0e8d1.png";